import { useStoreState } from '../../models/RootStore';

const MODBUS_FEATURE_KEY = 'isModbusShown';

/** Modbus is enabled for all users; per-user/localStorage gating is disabled below. */
export const useIsModbusEnabled = (): boolean => true;
// useStoreState((s) => !!s.users.me?.enableModbus) || localStorage.getItem(MODBUS_FEATURE_KEY) === 'true';
